import { TCall } from './types'

// A call that never connected says so, rather than being described purely
// by its direction.
export const getCallTypeLabel = (
 direction?: TCall['direction'],
 status?: TCall['status'],
): string => {
 const isInbound = direction === 'inbound'
 switch (status) {
  case 'no-answer':
   return isInbound ? 'Missed Call' : 'No Answer'
  case 'busy':
   return isInbound ? 'Missed Call' : 'Line Busy'
  case 'failed':
   return 'Call Failed'
  default:
   return isInbound ? 'Incoming Call' : 'Outgoing Call'
 }
}

export const formatCallDuration = (seconds?: number): string => {
 if (!seconds) return '--'
 const m = Math.floor(seconds / 60)
 const s = seconds % 60
 return `${m}m ${s.toString().padStart(2, '0')}s`
}

// North-American numbers render as "+1 (647) 367-0609"; anything else falls
// back to a leading "+" plus the raw digits since we don't know its format.
export const formatPhoneNumber = (raw?: string): string => {
 if (!raw) return ''
 const digits = raw.replace(/\D/g, '')
 if (digits.length === 11 && digits.startsWith('1')) {
  return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`
 }
 if (digits.length === 10) {
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
 }
 return raw.startsWith('+') ? raw : `+${digits}`
}
